import * as t from "io-ts";
import {ObjectFieldChangeArrayValidator} from "./object-field-change";

export const ObjectChangeLogValidator = t.intersection([
  t.type({
    id: t.string,
    objectId: t.string,
    objectType: t.string,
  }),
  t.partial({
    createdByPersonId: t.string,
    createdByPersonName: t.string,
    objectFieldChangeList: ObjectFieldChangeArrayValidator,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export const ObjectChangeLogArrayValidator = t.array(ObjectChangeLogValidator);

export type ObjectChangeLog = t.TypeOf<typeof ObjectChangeLogValidator>;
export type ObjectChangeLogArray = t.TypeOf<typeof ObjectChangeLogArrayValidator>;

export interface ObjectChangeLogEntry {
  fieldName?: string
  fromValue?: string
  toValue?: string
  createdByPersonId?: string
  createdByPersonName?: string
  createDttm?: number
}
